import React, { useCallback, createContext, useState, useMemo } from 'react';
import { fabric } from 'fabric';

export const FabricContext: any = createContext([]);

export const FabricContextProvider = ({ children }) => {
  const [canvas, setCanvas] = useState(null);
  const [activeObject, setActiveObject] = useState(null);

  const initCanvas = useCallback(el => {
    const canvasOptions = {
      preserveObjectStacking: true,
      selection: true,
      defaultCursor: 'default',
      backgroundColor: '#f3f3f3',
    };
    let c = new fabric.Canvas(el, canvasOptions);
    c.renderAll();
    setCanvas(c);
  }, []);

  const loadFromJSON = useCallback((el, json) => {
    let c = new fabric.Canvas(el);
    c.loadFromJSON(
      json,
      () => {
        c.renderAll.bind(c)();
        c.setWidth(json.width);
        c.setHeight(json.height);
      }
    );
    c.renderAll();
    setCanvas(c);
  }, []);

  const value = useMemo(
    () => ({
      canvas,
      initCanvas,
      loadFromJSON,
      activeObject,
      setActiveObject,
    }),
    [canvas, initCanvas, loadFromJSON, activeObject]
  );

  return (
    <FabricContext.Provider value={value}>
      {children}
    </FabricContext.Provider>
  );
};
